import React, { useState } from "react";
import { Checkbox, Space, Form, Input } from "antd";

const FilterCheckbox = ({ filter, showLabel = false }) => {
  const [checkboxFilter, setCheckboxFilter] = useState("");

  const onInputChange = ({ target: { value } }) => {
    setCheckboxFilter(value);
  };

  const onCheckboxChange = () => {
    setTimeout(() => setCheckboxFilter(""), 2000);
  };

  let filterValues = filter.values ? Object.values(filter.values) : [];
  filterValues = filterValues.filter((value) => value);

  return (
    <>
      {filterValues.length > 10 && (
        <Input
          onChange={onInputChange}
          placeholder={`Busque por ${filter.label}`}
          value={checkboxFilter}
          style={{ marginBottom: "20px" }}
        />
      )}

      <Form.Item name={filter.facet} label={showLabel && filter.label}>
        <Checkbox.Group
          onChange={onCheckboxChange}
          style={{ maxHeight: "300px", overflowY: "auto", width: "100%" }}
        >
          <Space direction="vertical" style={{ rowGap: "0px" }}>
            {filterValues.map(([id, label], i) =>
              id &&
              (label || "")
                .toLowerCase()
                .includes(checkboxFilter.toLowerCase()) ? (
                <Checkbox
                  key={`${id}-checkbox`}
                  value={id}
                  style={{ marginBottom: "8px" }}
                >
                  {label}
                </Checkbox>
              ) : (
                <Checkbox
                  key={`${id}-checkbox`}
                  value={id}
                  style={{ display: "none" }}
                >
                  {label}
                </Checkbox>
              )
            )}
          </Space>
        </Checkbox.Group>
      </Form.Item>
    </>
  );
};

export default FilterCheckbox;
